import { type ReactElement, useEffect, useState } from 'react';
import { ApplicationsService } from '@/services/ApplicationsService.ts'
import { type ApplicationsDto, type ApplicationDto, type FullApplicationsDto, type AppServicesDto, type AppServicesEnvDto, type EnvironmentClass } from '@/models/services.ts'
import { type APIEntryDto } from '@/models/apiConfiguration.ts'
import Loading from '../common/Loading.tsx';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import NoValue from '../common/NoValue.tsx';
import { useParams } from 'react-router';
import { HealthService } from '@/services/HealthService.ts';

export function ApplicationDetails(): ReactElement {

    
    let { key } = useParams();
    const [applications, setApplications] = useState<FullApplicationsDto | null>(null);
    const [applicationsSaved, setApplicationsSaved] = useState<FullApplicationsDto | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [showOnlyMineApp, setShowOnlyMineApp] = useState<boolean>(false);
    const [filter, setFilter] = useState<string>("");
    const healthService = new HealthService();
    
    const [selectedApplication, setSelectedApplication] = useState<FullApplicationsDto | null>(null);

    const RefreshData = () => {
        setIsLoading(true);
        new ApplicationsService().getAll(key!).then((applications: FullApplicationsDto) => {
            setIsLoading(false);
            setApplications(applications);
            setApplicationsSaved(applications);
            refreshDataHealth(applications!);
        });
    };

    const showOnlyMine = (e: React.ChangeEvent<HTMLInputElement>) => {
        const checked = e.target.checked;
        setShowOnlyMineApp(checked);
        FilterData(applicationsSaved!, filter, checked);

    }

    let isRefreshDataHealthRunning = false;
    let isRefreshDataHealthRunningCount = 0;
    const refreshDataHealth = (data: FullApplicationsDto): void => {
        if (!isRefreshDataHealthRunning )
        {
            isRefreshDataHealthRunningCount = 0;
            isRefreshDataHealthRunning = true;
            data?.apis.map((child) => {

                child.environments?.map((env) => {
                    if (env.healthCheckUri != null && env) {
                        if (env.healthCheckUri != null && env.healthCheckUri != "")
                        {
                            healthService.get(env.healthCheckUri!).then((result) => {
                                    env.status = formatHealth(result.status);
                                    env.errorMessage = result.errorMessage;
                            }).catch((error) => {
                                env.status = error.message;
                                env.errorMessage = "Failed to retrieve health status";
                            }).finally(()=> {
                                if (data != null && data != undefined) {
                                setApplicationsSaved(data);
                                }
                                FilterData(data, filter, showOnlyMineApp);
                            });
                        }
                        else {
                            env.status = "Url not set!"
                        }
                    }
                    isRefreshDataHealthRunningCount++;
                    if (isRefreshDataHealthRunningCount >= (child.environments.length)) {
                        isRefreshDataHealthRunningCount = 0;
                        isRefreshDataHealthRunning = false;
                    }
                })
            });
        }
    }
    const formatHealth = (str) => {
        if (str == null)
            str = "Unknow";
        else if (str.toLowerCase() == "up")
            str = "healthy";
        else if (str.toLowerCase() == "down")
            str = "unhealthy";
        return str.charAt(0).toUpperCase() + str.slice(1);
        }

    const FilterData = (data: FullApplicationsDto , value: string, showOnlyMine: boolean) => {
        if (data) {
            const filteredWebApps = data.webapps.filter((app: ApplicationDto) => app.name.toLowerCase().includes(value.toLowerCase()));
            const filteredApis = data.apis.filter((app: AppServicesDto) => app.name.toLowerCase().includes(value.toLowerCase()));

            if(showOnlyMine) {
                var _app: FullApplicationsDto = {
                    webapps : filteredWebApps?.filter((app: ApplicationDto) => app.userInTeam) ?? [],
                    apis: filteredApis?.filter((app: AppServicesDto) => app.userInTeam) ?? [],
                }
                setApplications(_app);
                return;
            }
            setApplications({
                webapps: filteredWebApps ?? [],
                apis: filteredApis ?? []
            });
        } else {
            setApplications(null);
        }
    }
  
    const setShowSearchText = (value: string) => {
        setFilter(value);
        FilterData(applicationsSaved!, value, showOnlyMineApp);
    }

  const DisplayEnvironments = (key: string, environments: EnvironmentClass[]) => {
    const OpenWindow = (e: any, url: string) => {
      window.open(url, '_blank').focus();
      e.stopPropagation();
      e.preventDefault();
      return false;
    }

    return environments?.map(({ name, status, statusPingdom, urls }) =>
      statusPingdom != null ? (

        <Col md="3" className='text-truncate form-label ' key={`env_${key}_${name}`}><span className=' text-uppercase'>{name}</span>
          <div className='mt-2' style={{lineHeight:"25px"}}>   
            <a target='_blank' href={urls[0]}>         
              <span  title={urls[0]} className={ `rounded-pill badge-md ps-3 pe-3 pt-1 pb-1 badge badge-${status == null ? 'danger' : status === 'Healthy' ? 'discreet-success' : status === 'Unhealthy' || status === 'Error' ? 'danger' : 'warning'}` }>
                  {' '}
                  {status ?? 'Unknow'}{' '}
              </span>
            </a>
          </div>
          {statusPingdom != null ? 
            <div className='mt-2' style={{lineHeight:"25px"}}>          
              <span className={ `rounded-pill badge-md ps-3 pe-3 pt-1 pb-1 badge badge-${status == null ? 'danger' : status === 'Healthy' ? 'discreet-success' : status === 'Unhealthy' || status === 'Error' ? 'danger' : 'warning'}` }>
                  Pingdom:{' '}
                  {status ?? 'Unknow'}{' '}
              </span>
          </div>
          : null
          }
      </Col>
      ) : (
        <Col md="3" className='text-truncate form-label ' key={`env_${key}_${name}`}><span className=' text-uppercase'>{name}</span>
          <div className='mt-2' style={{lineHeight:"25px"}}>        
            <a target='_blank' href={urls[0]}>  
              <span title={urls[0]} className={ `rounded-pill badge-md ps-3 pe-3 pt-1 pb-1 badge badge-${status == null ? 'danger' : status === 'Healthy' ? 'discreet-success' : status === 'Unhealthy' || status === 'Error' ? 'danger' : 'warning'}` }>
                  {' '}
                  {status ?? 'Unknow'}{' '}
              </span>
            </a>
          </div>
      </Col>
      )
    );
  }
  
     const DisplayApiEnvironments = (key: string, environments: AppServicesEnvDto[]) => {
    
        return environments?.map(({ name, status, errorMessage, healthCheckUri }) =>
            healthCheckUri != null ? (
    
            <Col md="2" className='text-truncate form-label ' key={`env_${key}_${name}`}><span className=' text-uppercase'>{name}</span>
              <div className='mt-2' style={{lineHeight:"25px"}}>  
                <a target='_blank' href={healthCheckUri}>                       
                  <span title={errorMessage != null && errorMessage != "" ? errorMessage+": "+healthCheckUri : healthCheckUri} className={ `rounded-pill badge-md ps-3 pe-3 pt-1 pb-1 badge badge-${status == null ? 'danger' : status === 'Healthy' ? 'discreet-success' : status === 'Unhealthy' ? 'danger' : 'warning'}` }>
                      {' '}
                      {status ?? 'Unknow'}{' '}
                  </span>
                  </a>
              </div>
          </Col>
          ) : (
            <Col md="2" className='text-truncate form-label ' key={`env_${key}_${name}`}><span className=' text-uppercase'>{name}</span>
              <div className='mt-2' style={{lineHeight:"25px"}}>    
                <span title="HealthCheck Url was not set" className={ `rounded-pill badge-md ps-3 pe-3 pt-1 pb-1 badge badge-${healthCheckUri == null ? 'danger' : 'discreet-success'}` }>
                    {' '} Unset {' '}
                </span>
              </div>
          </Col>
          )
        );
      }

    useEffect(() => {
        RefreshData();
    }, []);

    return (
        <div>
            <h2>Filters:</h2>
            <Row>
            <Col md="6">
                    <div className="form-group">
                        <label htmlFor="searchText" className="form-label">Search</label>
                        <input type="text" className="form-control" id="searchText" placeholder="Search..." onChange={(e) => setShowSearchText(e.target.value)} />
                    </div>
                </Col>
                <Col md="6" className='pt-4'>
                    <div className="form-group form-check">
                        <input type="checkbox" className="form-check-input"  onChange={(e) => showOnlyMine(e)}/>
                        <label className="form-check-label" >Only show mine</label>
                    </div>
                </Col>
            </Row>
            <h2 className='mt-4'>Application</h2>
            <Row className='mt-2'>
                
                {isLoading ? <Loading isLoading={isLoading} /> : 
                <>
                    <h4 className='mt-5 mb-3'>Web Applications</h4>
                    <table className='table table-sm table-striped table-hover'>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Environments</th>
                                <th>Type</th>
                                <th>Life Cycle</th>
                                <th>Hosting</th>
                            </tr>
                        </thead>
                    <tbody>
                    {
                        applications?.webapps?.map((app: ApplicationDto)  => (
                            <tr key={app.key}>
                                <td width={300} >{app.name}</td>
                                <td><Row>{DisplayEnvironments(app.name, app.environments)}</Row></td>
                                <td width={100} style={{ textAlign: 'left' }}>{app.type}</td>
                                <td width={100} style={{ textAlign: 'left' }}>{app.lifeCycle}</td>
                                <td width={100} style={{ textAlign: 'left' }}>{app.hosting}</td>
                            </tr>
                        ))
                    }
                    </tbody>
                    </table>
                    <h4 className='mt-5 mb-3'>Apis</h4>
                    <table className='table table-sm table-striped table-hover'>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Environments</th>
                                <th>Type</th>
                                <th>Life Cycle</th>
                                <th>Exposition</th>
                            </tr>
                        </thead>
                    <tbody>
                    {
                        applications?.apis?.map((app: AppServicesDto) => (
                            <tr key={app.name}>
                                <td width={300} >{app.name}</td>
                                <td><Row>{DisplayApiEnvironments(app.name, app.environments)}</Row></td>
                                <td width={100} style={{ textAlign: 'left' }}>api</td>
                                <td width={100} style={{ textAlign: 'left' }}>{app.lifeCycle}</td>
                                <td width={100} style={{ textAlign: 'left' }}>{app.exposition}</td>
                            </tr>
                        ))
                    }
                    </tbody>
                    </table>
                </>
                }
            </Row>
        </div>
    );

}